<template>
  <div v-if="template">
    <div class="content-template" v-if="getTemplateHeader">
      <strong>{{ $t('WHATSAPP_TEMPLATES.PARSER.HEADER') }}</strong>

      <p v-if="getTemplateHeader.text" class="template-text">
        {{ getTemplateHeader.text }}
      </p>

      <div v-else>
        <fluent-icon :icon="getIconTemplateHeader" size="20" />
      </div>
    </div>

    <div class="content-template">
      <strong>{{ $t('WHATSAPP_TEMPLATES.PARSER.BODY') }}</strong>

      <p class="template-text">
        {{ bodyPreviewText }}
      </p>
    </div>

    <div v-if="getTemplateButtons.length" class="content-template">
      <strong>{{ $t('WHATSAPP_TEMPLATES.PARSER.BUTTONS') }}</strong>

      <div class="template-buttons">
        <div
          v-for="(button, index) in getTemplateButtons"
          :key="index"
          class="template-button"
        >
          {{ buttonLabel(button) }}
        </div>
      </div>
    </div>

    <div v-if="getTemplateFooter" class="content-template">
      <strong>{{ $t('WHATSAPP_TEMPLATES.PARSER.FOOTER') }}</strong>

      <p class="template-text">
        {{ getTemplateFooter }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    template: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isAuthenticationTemplate() {
      return this.template?.category?.toUpperCase() === 'AUTHENTICATION';
    },
    bodyPreviewText() {
      if (this.isAuthenticationTemplate) {
        return this.$t(
          'WHATSAPP_TEMPLATES.PARSER.AUTHENTICATION_BODY_PREVIEW',
          { code: '{{1}}' }
        );
      }

      return this.getTemplateBody;
    },
    getIconTemplateHeader() {
      const { format } = this.getTemplateHeader;

      switch (format) {
        case 'IMAGE':
          return 'image';
        case 'DOCUMENT':
          return 'document';
        case 'VIDEO':
          return 'video-add';
        default:
          return '';
      }
    },
    getTemplateHeader() {
      return this.template.components
        ? this.template.components.find(({ type }) => type === 'HEADER')
        : null;
    },
    getTemplateBody() {
      return this.template.components
        ? this.template.components.find(({ type }) => type === 'BODY')?.text
        : null;
    },
    getTemplateFooter() {
      return this.template.components
        ? this.template.components.find(({ type }) => type === 'FOOTER')?.text
        : null;
    },
    getTemplateButtons() {
      const buttonsComponent = this.template.components
        ? this.template.components.find(({ type }) => type === 'BUTTONS')
        : null;

      return buttonsComponent?.buttons || [];
    },
  },
  methods: {
    buttonLabel(button) {
      if (button.text) return button.text;
      if (button.type === 'OTP') {
        return this.$t('WHATSAPP_TEMPLATES.PARSER.AUTHENTICATION_BUTTON_LABEL');
      }

      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.content-template {
  margin-bottom: var(--space-two);
}

.template-text {
  margin: 4px 0 0;
  white-space: pre-line;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
}

.template-buttons {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 320px;
}

.template-button {
  padding: 8px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fafafa;
  color: #00a884;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
}
</style>